export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";